'use strict';

var createMiddleware = require('./middleware');

module.exports = {
  createMiddleware: createMiddleware
};